import { LevelSpec } from '../game/LevelSpec';
export default new LevelSpec({
    title: 'First Steps',
    goal: 'Move the Robot <keyword type="robot">Red</keyword> to the <keyword type="goal">Flag</keyword>.',
    testGoal: (world) => world.robotsAtGoals().length ? { win: true } : undefined,
    helpText: `
		<p>
			Meet your friendly chef-bot, <keyword type="robot">Red</keyword>.
		</p>

		<p>
			You can tell Red what to do by <b>calling methods</b> on them. Methods are sets
			of instructions you can give to <keyword>objects</keyword> like your robot.
		</p>

		<p>
			You will need to know three methods to solve this puzzle:
		</p>

		<ul>
			<li><code>red.walk()</code> will tell Red to walk forward a step</li>
			<li><code>red.turn_left()</code> will tell Red to turn left, and</li>
			<li><code>red.turn_right()</code> will tell them to turn right.</li>
		</ul>

		<p>
			You can call multiple methods, one after the other on each line. For example,
			this program will walk forward a space, turn right and then walk two more spaces:
		</p>

		<code-block>
			red.walk()
			red.turn_right()
			red.walk()
			red.walk()
		</code-block>
	`,
    lockedLines: 3,
    defaultCode: `
		from kitchen import *

		red = robots.get( 'red' )
		
		red.walk()
		red.turn_right()
		red.walk()
		red.walk()
	`,
    layout: [
        '......',
        '.r....',
        '......',
        '......',
        '....g.',
        '......',
    ],
});
